import { AppState } from '../../../redux/initialStates/AppState';
import { IRevenueCenters } from '../initialStates/revenueCenters';

export const selectRevenueCentersState = (state: AppState): IRevenueCenters => state.table.revenueCenters;
